import * as React from 'react'
import { SVGProps } from 'react'

const SvgPolygonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx={16} cy={16} r={16} fill='#8247E5' />
    <path
      d='M21.349 12.024c-.38-.219-.869-.219-1.303 0l-3.042 1.802-2.063 1.146-2.987 1.802c-.38.218-.87.218-1.304 0l-2.335-1.42a1.332 1.332 0 0 1-.652-1.146v-2.73c0-.437.218-.874.652-1.147l2.335-1.365c.38-.218.87-.218 1.304 0l2.335 1.42c.38.218.652.655.652 1.146v1.802l2.063-1.201v-1.856c0-.437-.217-.874-.651-1.147l-4.345-2.566c-.38-.219-.869-.219-1.303 0L6.25 9.184c-.434.219-.651.656-.651 1.093v5.132c0 .437.217.873.651 1.146l4.4 2.567c.38.218.868.218 1.303 0l2.987-1.747 2.063-1.202 2.987-1.747c.38-.218.87-.218 1.304 0l2.335 1.365c.38.218.652.655.652 1.147v2.73c0 .437-.218.873-.652 1.146l-2.281 1.365c-.38.219-.869.219-1.303 0l-2.336-1.365a1.332 1.332 0 0 1-.651-1.146V17.92l-2.064 1.2v1.803c0 .436.217.873.652 1.146l4.399 2.566c.38.219.869.219 1.303 0l4.399-2.566c.38-.218.652-.655.652-1.146v-5.188c0-.436-.218-.873-.652-1.146l-4.399-2.566Z'
      fill='#fff'
    />
  </svg>
)

export default SvgPolygonIcon
